import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";
import VolumeSlideBar from "../../VolumeSlideBar";

const VolumeControl = ({
  volumeRef,
  onMouseEnter,
  onMouseLeave,
  isMuted,
  volumeLevel,
  translate,
  volumeButtonRef,
  volumeButtonHandler,
  volumeVisibility,
  playerMgr,
  onVolumeSlideChange,
  volumeBarRef,
}) => {
  const theme = useTheme();
  return (
    <div ref={volumeRef} className="player-popup-container" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <VideoPlayerButtonComponent
        src={
          isMuted
            ? process.env.PUBLIC_URL + "/images/volume-mute.svg"
            : volumeLevel && volumeLevel >= 50
            ? process.env.PUBLIC_URL + "/images/volume-high.svg"
            : process.env.PUBLIC_URL + "/images/volume-low.svg"
        }
        alt={translate("volume")}
        buttonClassName="volumeButton"
        ref={volumeButtonRef}
        onClickHandler={volumeButtonHandler}
        $hoverBackgroundColor={theme.colours.mineShaftGray}
      />
      {volumeVisibility ? (
        <div className="volume-slider-container">
          <VolumeSlideBar
            playerMgr={playerMgr.current}
            audioLevel={volumeLevel}
            onChange={onVolumeSlideChange}
            isMuted={isMuted}
            ref={volumeBarRef}
          ></VolumeSlideBar>
        </div>
      ) : null}
    </div>
  );
};

export default VolumeControl;
